

























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import { Prop, ProvideReactive, Watch } from 'vue-property-decorator'
import AdminUserWalletLogTable from '@/modules/wallet-log/components/admin/table/AdminUserWalletLogTable.vue'
import { AdminGetWalletLogUseCase } from '@/modules/wallet-log/use-cases/admin/admin-get-wallet-log.use-case'
import Pagination from '@/modules/shared/components/shared/pagination/Pagination.vue'

@Component({
  components: {
    Pagination,
    AdminUserWalletLogTable,
    SimpleHeader
  }
})
export default class AdminUserWalletLogSection extends Vue {
  constructor(
    private readonly useCase: AdminGetWalletLogUseCase
  ) {
    super()
  }

  @Prop({ required: true }) userId: number
  @Prop({ default: () => ({}) }) params: Record<string, string | number | boolean>
  @Prop({ default: 'timer-outline' }) icon: string
  @Prop({ default: 'تاریخچه تغییرات' }) header: string
  @Prop({ default: false }) noHeader: boolean
  @Prop() isUpdated: boolean

  @ProvideReactive()
  private get fixedData() {
    return {
      types: this.useCase.getLogs['types'],
      wallet_types: this.useCase.getLogs['wallet_types']
    }
  }

  protected goto(page: number) {
    return this.useCase.execute(this.userId, page, this.params)
  }

  beforeMount() {
    this.goto(1)
  }

  @Watch('isUpdated', { immediate: true })
  onUpdateChange(newVal) {
    if (newVal === true) {
      this.goto(1)
    }
  }
}
